/**
 * Parses data-* attributes from an acquisition form host element
 * into a normalized config override object.
 *
 * Supported attributes:
 *   data-tm-acquisition-form-id      → acquisitionFormId (required)
 *   data-tm-campaign-id    → campaignId
 *   data-tm-display        → display: 'ButtonModal' | 'Inline' | 'ProjectPicker' | 'ItemPicker'
 *   data-tm-goal           → goal: 'Donation' | 'Lead'
 *   data-tm-config-json    → configJson (preview-only)
 *   data-tm-config-source  → configSource: 'Api' | 'Local' | 'Auto'
 *   data-tm-preview        → preview: 'true' | '1' (overrides the script flag)
 *
 * Payloads that are not attributes (the picker card lists) are read by
 * the registered display mode at mount time, not here.
 *
 * @param {HTMLElement} element
 * @returns {{ acquisitionFormId: string|null, campaignId: string|null, display: string|null, goal: string|null, configJson: string|null, configSource: string|null, preview: string|null }}
 */
export function parseDataAttributes(element) {
  const dataset = element.dataset;

  return {
    acquisitionFormId: dataset.tmAcquisitionFormId || null,
    campaignId: dataset.tmCampaignId || null,
    display: dataset.tmDisplay || null,
    goal: dataset.tmGoal || null,
    configJson: dataset.tmConfigJson || null,
    configSource: dataset.tmConfigSource || null,
    preview: dataset.tmPreview || null
  };
}

/**
 * Infers the default display mode from the element tag name
 * when data-tm-display is not explicitly set.
 *
 * @param {HTMLElement} element
 * @returns {'ButtonModal'|'Inline'}
 */
export function inferDisplayMode(element) {
  const inlineTags = ['DIV', 'SECTION', 'ARTICLE', 'FORM', 'MAIN', 'ASIDE'];
  return inlineTags.includes(element.tagName) ? 'Inline' : 'ButtonModal';
}
